import { Modal } from "react-bootstrap";

const ModalPdfView = (props) => {
  return (
    <>
      <Modal {...props} size="xl" centered fullscreen={false} contentClassName="bg-dark " backdrop="static">
        <Modal.Header className="border-0" closeButton>
          <strong className="text-white">Visor de documentos PDF</strong>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ background: "#2f3237" }}>
          <div>
            <div>
              <embed src={props.pdf} className="w-100" style={{ height: "80vh" }} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalPdfView;
